<template>
  <a href="https://t.me/jobgov_bot" target="_blank" class="telegram">
    <div class="icon">
      <b-icon-envelope-fill />
    </div>
    <div class="text">
      Підключіть нашого бота в <strong> Telegram</strong>,та першими отримуйте
      свіжі вакансій та новини.
    </div>
  </a>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
.telegram {
  padding: 20px;
  background: #0088cc;
  border-radius: 8px;
  box-shadow: 0px 6px 14px 0px rgba(#0088cc, 0.3);
  min-height: 100%;
  display: block;
  text-decoration: none;
  color: #fff;
  align-items: center;
  transition: 0.3s;
  display: flex;
  .icon {
    font-size: 72px;
    margin-right: 30px;
  }
  &:hover {
    background: lighten(#0088cc, 5%);
    transition: 0.3s;
  }
}
</style>
